import { BPContainer } from '@/components/bp/bpcontainer';
import { Container, Divider, Grid, Header } from 'semantic-ui-react';

interface AuthLayoutProps {
    header?: React.ReactNode;
    description?: React.ReactNode;
    children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ header, description, children }) => {
    return (
        <BPContainer>
            <Grid centered>
                <Grid.Row>
                    <Grid.Column mobile={16} tablet={8} computer={6}>
                        <div className="mainlogo"></div>
                    </Grid.Column>
                </Grid.Row>
                {header && <Grid.Row>
                    <Grid.Column mobile={16} tablet={8} computer={6} textAlign='center'>
                        <Header as="h2">{header}</Header>
                        <Divider />
                        <p>{description}</p>
                    </Grid.Column>
                </Grid.Row>}
                {children}
            </Grid>
        </BPContainer>

    );
};
